// extracted by mini-css-extract-plugin
export default {"customers__modal":"Customers_customers__modal__szrmp","customers__addmodal":"Customers_customers__addmodal__DHIBT","table_wrapper":"Customers_table_wrapper__FOeCt"};